import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Button from "../Components/Button";
import Modal from "../Components/Modal";

import RequestForm from "./RequestQuote/GenericInquiryForm";

const QuoteModal = ({
    buttonLabel = "Request a Quote",
    quoteProduct,
    quoteSeller,
    is_in_stock,
    countries,
    hubspotLists = [],
    isProductAction = false,
    ...props,
}) => {
    const [loaded, setLoaded] = useState(false);
    const [activeModal, setActiveModal] = useState("none");

    useEffect(() => {
        setLoaded(true);
    }, []);

    if (typeof is_in_stock == "string") {
        is_in_stock = is_in_stock === "";
    }

    const openForm = () => {
        setActiveModal("form");
    };

    const openSuccess = () => {
        setActiveModal("success");
    };

    const closeModal = () => {
        setActiveModal("none");
    };

    return (
        <div className="request-quote">
            {is_in_stock ? (
                loaded ? (
                    <Button
                        label={buttonLabel}
                        icon="fas fa-file-edit"
                        className="btn highlight"
                        onClick={openForm}
                        other={{
                            "data-target": "#quoteModal",
                            "data-toggle": "modal",
                        }}
                    />
                ) : (
                    <a
                        href={`inquires/?product=${quoteProduct.sku}`}
                    >
                        {buttonLabel}
                    </a>
                )
            ) : (
                <Button
                    label="Item is out of stock"
                    className="btn highlight"
                    disabled={true}
                />
            )}
            <Modal
                key="form-modal"
                id="quoteModal"
                size="lg"
                title="Request A Quote"
                open={activeModal === "form"}
                isOverlay={activeModal === "form"}
                close={closeModal}
            >
                <RequestForm
                    countries={countries}
                    quoteProduct={quoteProduct}
                    quoteSeller={quoteSeller}
                    onSuccess={openSuccess}
                    hubspotLists={hubspotLists}
                    isProductAction={isProductAction}
                    {...props}
                />
            </Modal>
            <Modal
                key="success-modal"
                open={activeModal === "success"}
                isOverlay={activeModal === "success"}
                close={closeModal}
            >
                <div className="text-center text-success modal-message p-4">
                    <i className="fas fa-check-circle fa-4x" />
                    <h3 className="text-center mb-4">
                        Your quote has successfully been made
                    </h3>
                    <Button
                        label="Return"
                        onClick={closeModal}
                    />
                </div>
            </Modal>
        </div>
    );
};

QuoteModal.propTypes = {
    buttonLabel: PropTypes.string,
    quoteProduct: PropTypes.object,
    quoteSeller: PropTypes.object,
    is_in_stock: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    countries: PropTypes.object,
    hubspotLists: PropTypes.array,
    isProductAction: PropTypes.bool
};

export default QuoteModal;
